import { PlayoffMatchup } from '../playoffs/playoff.model';
import { TournamentGame } from './tournament.model';

export function tournamentPlayoffGameStatus(matchup: PlayoffMatchup): TournamentGame['status'] {
  if (matchup.schedule_status === 'completed') return 'completed';
  if (matchup.schedule_status === 'cancelled') return 'cancelled';
  if (matchup.schedule_status) return 'scheduled';
  return matchup.home_score !== null && matchup.away_score !== null ? 'completed' : 'scheduled';
}
